<template>
  <div>
 
<v-card flat class="px-4 pb-4">
    <v-subheader>
        Contract Steps
        <v-spacer></v-spacer>
         <availableDocuments
        title="Available documents"
        :documents="contractDocuments"
      />
      </v-subheader>

    <v-layout row justify-center mt-2>
      <v-expansion-panel
        v-model="selectedPanel"
        v-if="contract && contract.steps && contract.steps.length"
        class="elevation-0 mini"
      >
        <v-expansion-panel-content
          v-for="(step, i) in contractSteps"
          :key="step.id"
          :v-model="i"
          expand
          ripple
        >
          <div slot="header">
            <v-layout row>
              <v-icon :color="stepIconColor(step)" style="padding-right: 12px;"
                >check_circle</v-icon
              >
              <v-flex>
                <span :style="lineThrough(step.validated)">
                  {{ step.step_template.name.toUpperCase() }}
                </span>
              </v-flex>
              <v-flex>
                <v-layout v-if="step.validated" justify-end mx-4>
                  <span
                    style="color: #424242;"
                    class="font-italic text-xs-right"
                    >Set as done {{ step.updated_at | timeAgo }}</span
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </div>

          <v-card>
            <stepCard
              :stepId="step.id"
              @stepValidated="stepValidated"
              :open="i === selectedPanel"
              :noScroll="true"
            />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
    </v-card>
  </div>

</template>
<script>
import { mapGetters } from "vuex";
import steps from "../../mixins/steps.js";
import date from "../../mixins/date.js";
import availableDocuments from "../contracts/availableDocuments";
export default {
  mixins: [steps, date],
  components: {
    availableDocuments,
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "contractDocuments",
      "contractSteps",
    ]),
  },
  methods: {
    getGroupSteps() {
      return this.contractSteps;
    },
  },
};
</script>

<style lang="stylus">
.mini {
  .v-expansion-panel__header {
    min-height: 0;
    padding: 3px 24px !important;
  }
}
</style>
